import React from 'react';
import useTheme from '../hooks/useTheme';

interface PlaceholderImageProps {
  label: string;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
}

export const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  label,
  width = '100%',
  height = 300,
  style = {},
}) => {
  const { theme } = useTheme();

  const svgContent = `
    <svg width="${typeof width === 'number' ? width : '100%'}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="${theme.background.panel}"/>
      <rect x="0" y="0" width="100%" height="4" fill="${theme.colors.accent.korea}"/>
      <rect x="0" y="${typeof height === 'number' ? height - 4 : 'calc(100% - 4px)'}" width="100%" height="4" fill="${theme.colors.accent.egypt}"/>
      <text x="50%" y="50%" font-family="system-ui, -apple-system, sans-serif" font-size="16" fill="${theme.text.muted}" text-anchor="middle" dominant-baseline="middle">${label}</text>
    </svg>
  `.trim();

  const dataUri = `data:image/svg+xml;utf8,${encodeURIComponent(svgContent)}`;

  return (
    <img
      src={dataUri}
      alt={label}
      style={{
        width,
        height,
        objectFit: 'cover',
        borderRadius: theme.borderRadius.r1,
        display: 'block',
        ...style,
      }}
    />
  );
};

